import { TabelasAdministrativas } from '@core/models/tabelasAdministrativas';

export class TipoDocumento extends TabelasAdministrativas {
	constructor(id?: number, nome?: string, ativo?: boolean) {
		super(id, nome, ativo);
	}
}
